module.exports = __webpack_public_path__ + "static/media/heading_design.f37e7b0b.jpg";